import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../auth/AuthContext'

/** Route-level auth gate — wraps a set of routes that all require login. */
export default function RequireAuth() {
  const { claims, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        height: '100vh', color: 'var(--text-secondary)'
      }}>
        Loading…
      </div>
    )
  }

  if (!claims) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <Outlet />
}
